// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Zc41n","wrapper":"styles_wrapper__1Qbp5"};